import { render, staticRenderFns } from "./Resumes.vue?vue&type=template&id=3409acb6&scoped=true&"
import script from "./Resumes.vue?vue&type=script&lang=ts&"
export * from "./Resumes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3409acb6",
  null
  
)

export default component.exports